



















































import Vue from 'vue';
import Component from 'vue-class-component';
import { getModule } from 'vuex-module-decorators';
import store from '../../store';
import { PhaseTypeDto } from '../../models/PhaseTypeDto';
import { PhaseAliasDto } from '../../models/PhaseAliasDto';
import { DxButton, DxToolbar, DxTextBox, DxTagBox, DxForm, DxScrollView } from 'devextreme-vue';
import { DxItem } from 'devextreme-vue/form';
import { DxToolbarItem } from 'devextreme-vue/popup';
import CustomStore from 'devextreme/data/custom_store';
import CommonModule, { QuestelServicesClient, RequestResult, HttpMethodEnum } from '@questelservices/common';
import { Prop, Watch } from 'vue-property-decorator';
import { PhaseAliasService } from '../../service/PhaseAliasService';
import { SelectOption } from '../../models/SelectOption';
import notify from 'devextreme/ui/notify';
import { Popup } from '@questelservices/common-vue';

const commonState = getModule(CommonModule, store);

@Component({
  components: {
    DxButton,
    DxToolbar,
    DxToolbarItem,
    DxTextBox,
    DxTagBox,
    DxForm,
    DxItem,
    DxScrollView,
    Popup
  }
})
export default class PhaseAliasesEdit extends Vue {    
  @Prop({ default: false })
  showEdit!: boolean;

  @Prop()  
  phaseAlias!: PhaseAliasDto;

  phaseAliasService: PhaseAliasService;
  allPhaseTypes: Array<SelectOption> = [];

  aliasId: Guid = "";
  aliasName: string = "";
  aliasPhases: Array<number> = [];

  get showingEdit() {
      return this.showEdit;
  }

  set showingEdit(value) {
      this.$emit("hiding");
  }

  @Watch("showEdit")
    onPropertyChanged(value: boolean, oldValue: boolean) {
        if (value) {     
          this.loadAlias();
        }
    }

  constructor() {
    super();      
    this.phaseAliasService = new PhaseAliasService(
      '/api/PhaseAlias'
    );     

    this.loadData();
  }

  loadAlias(): void {
    //create
    if(!this.phaseAlias) {
      this.aliasId = "";
      this.aliasName = "";
      this.aliasPhases = [];
    }
    //edit
    else {
      this.aliasId = this.phaseAlias.PhaseAliasId;
      this.aliasName = this.phaseAlias.Name;
      this.aliasPhases = this.phaseAlias.PhaseTypeIds;
    }    
  }

  async loadData() {
    let client = new QuestelServicesClient(this.$store, '');  
    let phaseTypes = await client.get<PhaseTypeDto[]>('/api/phasetype/all');

    this.allPhaseTypes =  phaseTypes.map(p => {
      return { text: p.PhaseName, value: p.PhaseTypeId };
    });     
  }

  private saveAlias() {
    if(this.aliasName == "") {
      notify("Please enter a valid alias name", "error", 1000);
      return;
    }

    if(this.aliasPhases.length == 0) {
      notify("Please enter at least one phase", "error", 1000);
      return;
    }
    
    let phaseAliasDto = new PhaseAliasDto();
    phaseAliasDto.Name = this.aliasName;
    phaseAliasDto.PhaseTypeIds = this.aliasPhases;
    phaseAliasDto.PhaseAliasId = "00000000-0000-0000-0000-000000000000";

    //create
    if(this.aliasId == "") {
      this.phaseAliasService.create(phaseAliasDto)
        .then(result => {
          if(result.Data.Name == null) {
            notify("An alias with this name exists. Please choose a different name.", "error", 1000);
            return;
          }
          this.hidingEdit();
        });
    }
    //edit
    else {
      phaseAliasDto.PhaseAliasId = this.aliasId;
      this.phaseAliasService.edit(this.aliasId, phaseAliasDto)
        .then(result => {
          if(result.Data.Name == null) {
            notify("An alias with this name exists. Please choose a different name.", "error", 1000);
            return;
          }
          this.hidingEdit();
        });
    }    
  }

  hidingEdit() {    
    this.showingEdit = false;
  } 
}
